import { UseMutateFunction, useQueryClient } from '@tanstack/react-query';

import { useMutation } from '@hooks/reactQuery';

import { useAppDispatch } from '@store/store';

import { setSnackbar } from '@slices/common';

import { enableConsistencyCheckRanMonitoring } from '@api/consistencyCheck';

import { IId } from '@interfaces/common/common';

import { ESnackbarTypes, EUserRoles } from '@enums/common';

import { CONSISTENCY_RAN_ENABLE_MONITORING, CONSISTENCY_RAN_TABLE } from '@constants/queryKeys';
import { responseMessages } from '@constants/responseMessages';

interface IUseMutateConsistencyCheckRanEnableMonitoring {
	enableMonitoring: UseMutateFunction<any, any, IId, any>;
	isLoadingEnableMonitoring: boolean;
}

export const useMutateConsistencyCheckRanEnableMonitoring = (): IUseMutateConsistencyCheckRanEnableMonitoring => {
	const queryClient = useQueryClient();
	const dispatch = useAppDispatch();

	const {
		mutate,
		isLoading,
	} = useMutation<IId>({
		mutationKey: [CONSISTENCY_RAN_ENABLE_MONITORING],
		allowedRoles: [
			EUserRoles.networkOperatorCmModuleEditor,
			EUserRoles.networkOperatorCmModuleAdmin,
		],
		mutationFn: enableConsistencyCheckRanMonitoring,
		onSuccess: () => {
			dispatch(setSnackbar({
				message: responseMessages.enableMonitoringConsistencyCheckRanTemplate,
				type: ESnackbarTypes.success,
			}));

			return [queryClient.invalidateQueries([CONSISTENCY_RAN_TABLE])];
		},
	});

	return {
		enableMonitoring: mutate,
		isLoadingEnableMonitoring: isLoading,
	};
};
